import {Component, OnDestroy, OnInit} from '@angular/core';
import {Product} from "../product";
import {Website} from "../website";
import {ActivatedRoute} from "@angular/router";
import * as fromStore from "../../../store";
import {Store} from "@ngrx/store";
import {ActivityAction, IActivity} from "../../../activities/activity";
import {DbStoreState} from "../../../store";
import {User} from "../../../user/user";
import {Subject} from "rxjs";
import {Config} from "../../../config/config";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {filter, switchMap, takeUntil} from 'rxjs/operators';
import {Observable} from "rxjs";
import {DbModalService} from "../../../modules/modal/modal";
import {UserSubscription} from "../../../user/user-subscription";
import {combineLatest} from "rxjs";
import {OneMonthFreeComponent} from "../../../shared/components/dialogs/one-month-free/one-month-free.component";



@Component({
    selector: 'db-seo',
    templateUrl: './seo.component.html',
    styleUrls: ['./seo.component.scss'],
    standalone: false
})
export class SeoComponent implements OnInit, OnDestroy {

  public user: User;
  public currentSubscription: UserSubscription;
  public website: Website;
  public seoPlugin: Product;
  public isManagable: boolean;
  public loading: boolean;

  public ongoingActivity$: Observable<IActivity>;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _route: ActivatedRoute,
    private _store: Store<DbStoreState>,
    private _modalService: DbModalService,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {}

  ngOnInit() {
    this.website = this._route.snapshot.parent.data['website'];
    this.addEventHandlers();
    this.ongoingActivity$ = this._store.select(fromStore.getSeoOngoingActivity(this.website?.id, this.seoPlugin?.slug));
    this.ongoingActivity$
      .pipe(
        takeUntil(this._destroyStream$),
        filter(activity => !!activity)
      )
      .subscribe((activity) => {
        this.loading = !(activity.status === 'done' || activity.status === 'failed');
    });
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription)
        )),
        filter(([user, userSubscription]) => !!user && !!userSubscription)
      )
      .subscribe(([user, userSubscription]) => {
        this.user = user;
        this.currentSubscription = userSubscription;
        this.isManagable = !this.website.isLocalhost && this.seoPlugin && this.user.permissions.canManageContent;
      });
  }

  public ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  private addEventHandlers(): void {
    this._store.select(fromStore.getWebsiteSeoPlugin(this.website?.id))
      .pipe(
        takeUntil(this._destroyStream$),
        filter(seoPlugin => !!seoPlugin)
      )
      .subscribe((seoPlugin: Product) => {
        this.seoPlugin = seoPlugin;
    });
  }

  public installAndActivate(): void {
    if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId) {
      return this.showCheckoutDialog();
    }
    this.loading = true;
    let network = 0;
    if (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId)) {
      network = 1;
    }
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [this.seoPlugin],
      action: ActivityAction.INSTALL_ACTIVATE,
      network: network
    }));
  }

  public activate(): void {
    if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId) {
      return this.showCheckoutDialog();
    }
    this.loading = true;
    let network = 0;
    if (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId)) {
      network = 1;
    }
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [this.seoPlugin],
      action: ActivityAction.ACTIVATE,
      network: network
    }));
  }

  private showCheckoutDialog(): void {
    const analyticsData = {
      eventCategory: 'Free Upgrade Offer',
      eventAction: "Locked button click",
      eventLabel: "SEO"
    };
    const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
    modal.componentInstance.mode = 'feature';
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
